import { FSP_CONFIG } from "state/actions/fspConfig";
import { FspConfig } from "types";
import createReducer from "./createReducer";

export default createReducer<FspConfig>({ successType: FSP_CONFIG });
